export const NEW_TICKET = '/new-ticket';
export const MY_TICKETS = '/my-tickets';
export const TICKET = '/ticket/:id';
export const SUPPORT = '/support';
